import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const FolderDownloadIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 6C5.67157 6 5 6.67157 5 7.5V16.5C5 17.3284 5.67157 18 6.5 18H17.5C18.3284 18 19 17.3284 19 16.5V9.5C19 8.67157 18.3284 8 17.5 8H12.654C12.2567 8 11.8971 7.76481 11.7379 7.40082L11.3871 6.59918C11.2279 6.23519 10.8683 6 10.471 6H6.5ZM11.5757 15.4243C11.6883 15.5368 11.8409 15.6 12 15.6C12.1591 15.6 12.3117 15.5368 12.4243 15.4243L15.4243 12.4243L14.5757 11.5757L12.6 13.5515L12.6 10H11.4L11.4 13.5515L9.42426 11.5757L8.57574 12.4243L11.5757 15.4243Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { FolderDownloadIcon };
